import React, { useState } from 'react';
import MainLayout from '@/components/layout/MainLayout';
import AccommodationForm from '@/components/form/AccommodationForm';
import DeactivationDialog from '@/components/establishment/DeactivationDialog';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { HomeIcon, Building2Icon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from 'react-router-dom';
import { RoleBasedElement } from '@/features/auth/components/RoleBasedElement';
import { ROLES } from '@/features/auth/constants/roles';

const DetailEstablishment = () => {
  const [showDeactivationDialog, setShowDeactivationDialog] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleDeactivation = (data: {
    comments: string;
    date: Date;
    document: File | null;
  }) => {
    console.log('Deactivation data:', data);
    toast({
      title: "Establecimiento dado de baja",
      description: "El establecimiento ha sido dado de baja exitosamente.",
    });
    setShowDeactivationDialog(false);
  };

  const handleEdit = () => {
    navigate('/accommodation/editar/1');
  };

  const mockData = {
    // Simulated data for all form fields
    generalData: {
      name: "Hotel Las Sierras",
      type: "Hotel",
      category: "4 estrellas",
      address: "Av. Principal 123",
      city: "San Salvador de Jujuy",
      phone: "388-4123456",
      email: "contacto@hotellassierras.com",
      web: "www.hotellassierras.com",
    },
    services: {
      hasPool: true,
      hasWifi: true,
      hasParking: true,
      hasRestaurant: true,
    },
    rates: {
      singleRoom: 35000,
      doubleRoom: 45000,
      tripleRoom: 62000,
    },
    repat: {
      singles: "5",
      doubles: "15",
      triples: "8",
      totalRooms: "28",
    },
    samples: {
      paxLastNight: "45",
      occupiedRooms: "20",
      observations: "Sin observaciones particulares"
    }
  };

  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex justify-between items-start">
          <div>
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink href="/">
                    <HomeIcon className="h-4 w-4 mr-1" />
                    <span>Inicio</span>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage>Detalle del Establecimiento</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
            <h1 className="text-3xl font-bold mt-2 text-gray-900">Hotel Las Sierras</h1>
            <p className="text-gray-500 mt-1">
              Detalle completo del establecimiento
            </p>
          </div>
          <div className="flex gap-2">
            <RoleBasedElement requiredRoles={[ROLES.ADMIN, ROLES.FISCALIZACION_EDITOR]}>
              <Button 
                variant="destructive" 
                onClick={() => setShowDeactivationDialog(true)}
              >
                Baja
              </Button>
              <Button 
                variant="default"
                onClick={handleEdit}
              >
                Editar
              </Button>
            </RoleBasedElement>
          </div>
        </div>

        <AccommodationForm mode="view" defaultValues={mockData} />

        <DeactivationDialog
          open={showDeactivationDialog}
          onOpenChange={setShowDeactivationDialog}
          onConfirm={handleDeactivation}
        />
      </div>
    </MainLayout>
  );
};

export default DetailEstablishment;
